module.exports = __webpack_public_path__ + "static/media/4.61ef9185.jpg";